module.exports = __webpack_public_path__ + "static/img/5.def9861.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/eng/5.png
// module id = /R37
// module chunks = 0